import { Content, Episode, Season } from '../../apiService';

export type ShortEpisode = Episode & { seasonIndex: number };

/** Every episode of the short, flattened in play order and tagged with the season it came from. */
export const flattenEpisodes = (content?: Content): ShortEpisode[] => {
  const seasons = content?.short_info?.seasons || [];
  return seasons.flatMap((season, seasonIndex) => (season.episodes || []).map((episode) => ({
    ...episode,
    seasonIndex,
  })));
};

/** SeasonSelector reads `season`, which the shorts payload only fills in as `season_number`. */
export const getSeasons = (content?: Content): Season[] => {
  const seasons = content?.short_info?.seasons || [];
  return seasons.map((season, idx) => ({
    ...season,
    season: season.season_number ?? season.season ?? idx + 1,
  }));
};

/** Where playback resumes when the URL doesn't name an episode. */
export const resolveInitialFileId = (content?: Content) => {
  const { seasons = [], last_seen_file_id, last_seen_season, last_seen_episode } = content?.short_info || {};
  if (last_seen_file_id) return last_seen_file_id;

  const season = seasons.find(({ season_number }) => season_number === last_seen_season) || seasons[0];
  const episode = season?.episodes?.find(({ episode_number }) => episode_number === last_seen_episode) ||
    season?.episodes?.[0];

  return episode?.file_id;
};

/** Paid episodes are watchable only with an active subscription. */
export const isLocked = (episode: Episode | undefined, hasFullAccess: boolean) => (
  !!episode && !episode.is_free && !hasFullAccess
);

/** The episode is part of the path, so every episode change is a shareable URL. */
export const getEpisodeUrl = ({ short_id, slug }: Content, fileId?: string) => (
  `/shorts/${short_id}/${slug}${fileId ? `/${fileId}` : ''}`
);
